const doo3d = (() => {

    let timer = null;

    // 
    const init = (id, func) => {
        console.log('init')
        const baseUrl = process.env.NODE_ENV === 'production'
            ? 'https://studio.doo3d.com/api/gate/enter'
            : '/doo3d-api/api/gate/enter'
        timer = setTimeout(function () {
            // window.doo3d.start(`https://cloud.doo3d.com/gate/enter?id=${id}`, func, (err) => {
            window.doo3d.start(`${baseUrl}?id=50`, func, (err) => {
                alert(`${err}`);
            })
        }, 1000);
    }

    //
    const shutdown = () => {
        console.log('shutdown')
        window.doo3d.stop();
        if (timer != null) {
            clearTimeout(timer);
            timer = null;
        }
    }

    return { init: init, shutdown: shutdown };
})()

export default doo3d;